const numberToOrdinal = (n: number): string => {
  const ordinals = [
    'First',
    'Second',
    'Third',
    'Fourth',
    'Fifth',
    'Sixth',
    'Seventh',
    'Eighth',
    'Ninth',
    'Tenth',
    'Eleventh',
    'Twelfth',
    'Thirteenth',
    'Fourteenth',
    'Fifteenth',
    'Sixteenth',
    'Seventeenth',
    'Eighteenth',
    'Nineteenth',
    'Twentieth',
  ];
  return ordinals[n];
};

const questions = [
  { question: 'Mental capacity assessment', key: 'mentalCapacityAssessment' },
  {
    question:
      'Does the person have mental capacity now, when documenting their Advance Care Plan?',
    key: 'mentalCapacityStatus',
  },
  {
    question: 'Do you have a Next of Kin?',
    key: 'nextOfKinStatus',
  },
  { question: 'Next of Kin full name:', key: 'nfkFullName' },
  { question: 'Next of Kin relationship:', key: 'nfkRelationship' },
  { question: 'Next of Kin phone number:', key: 'nfkPhoneNumber' },
  {
    question:
      'Does the Next of Kin have a Lasting Power of Attorney for the resident’s Health and Welfare?',
    key: 'haveLPA',
  },
  {
    question:
      'Do you consent to having an Advance Care Plan created for you and held by us?',
    key: 'acpConsent',
  },
  {
    question: 'When should this Advance Care Plan be resisted and reviewed?',
    key: 'reviewDate',
  },
  {
    question: 'What name do you like to be called by?',
    key: 'preferredName',
  },
  {
    question: 'About Me',
    key: 'aboutMe',
  },

  {
    question: 'NHS number:',
    key: 'nhsNumber',
  },

  {
    question: 'Have you completed an LPA?',
    key: 'lpaStatus',
  },
];

enum SuccessNotiPositionEnum {
  FIRST = 'first',
  SECOND = 'second',
  THIRD = 'third',
  FOURTH = 'fourth',
  FIFTH = 'fifth',
  SIXTH = 'sixth',
  SEVENTH = 'seventh',
  EIGHTH = 'eighth',
  LAST = 'last',
}

export { numberToOrdinal, questions, SuccessNotiPositionEnum };

export interface ShowSuccessNotificationType {
  status: boolean;
  btnLoading: boolean;
  position: SuccessNotiPositionEnum;
}

export interface LastUpdatedType {
  id: string;
  fullName: string;
  email: string;
  updatedAt: string;
}
